export const initialsFromEmail = (email: string | undefined | null): string => {
  const localPart = email?.split("@")[0]?.trim() ?? "";
  if (!localPart) {
    return "";
  }

  const parts = localPart.split(/[._\-\s]+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0]?.[0] ?? ""}${parts[1]?.[0] ?? ""}`.toUpperCase();
  }

  return localPart
    .replaceAll(/[^a-z0-9]/gi, "")
    .slice(0, 2)
    .toUpperCase();
};
